import { VirtualItem } from "@tanstack/react-virtual";
import React, { memo, useMemo } from "react";

import { TreeItem } from "./TreeItem";

import { Entity } from "@/queries/folder-entities/types";

interface VirtualizedTreeItemProps {
  virtualItem: VirtualItem;
  entity: Entity;
  depth: number;
  isActive: boolean;
  isExpanded: boolean;
  onToggleFolder: (folderId: number) => void;
  onNavigate: (item: Entity) => void;
  getItemIcon: (item: Entity) => React.ReactNode;
  hasChildren: boolean;
  scrollMargin?: number;
}

export const VirtualizedTreeItem: React.FC<VirtualizedTreeItemProps> = memo(
  ({
    virtualItem,
    entity,
    depth,
    isActive,
    isExpanded,
    onToggleFolder,
    onNavigate,
    getItemIcon,
    hasChildren,
    scrollMargin = 0,
  }) => {
    const containerStyle = useMemo(
      () => ({
        position: "absolute" as const,
        top: 0,
        left: 0,
        width: "100%",
        height: `${virtualItem.size}px`,
        transform: `translateY(${virtualItem.start - scrollMargin}px)`,
      }),
      [virtualItem.size, virtualItem.start, scrollMargin],
    );

    return (
      <div style={containerStyle}>
        <TreeItem
          item={entity}
          depth={depth}
          isActive={isActive}
          isExpanded={isExpanded}
          hasChildren={hasChildren}
          onToggleFolder={onToggleFolder}
          onNavigate={onNavigate}
          getItemIcon={getItemIcon}
        />
      </div>
    );
  },
);

VirtualizedTreeItem.displayName = "VirtualizedTreeItem";
